import { render, staticRenderFns } from "./PolizasRHResponse.vue?vue&type=template&id=442f3866&scoped=true&"
import script from "./PolizasRHResponse.vue?vue&type=script&lang=js&"
export * from "./PolizasRHResponse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442f3866",
  null
  
)

export default component.exports